/** Existing listings may still have the legacy public_link access mode. */
export function isMarketplaceTest(test: {
  config?: { access?: unknown } | null;
  marketplaceStatus?: string | null;
} | null | undefined): boolean {
  const access = test?.config?.access;
  return (
    (typeof access === 'object' && access !== null && 'accessType' in access && access.accessType === 'marketplace') ||
    ['PENDING_REVIEW', 'APPROVED', 'REJECTED'].includes(test?.marketplaceStatus ?? '')
  );
}
